import { CustomizeCareerService, REDIRECT, CustomCropperAction, FILE_SIZES, IMAGE_VISIBILITIES, CommonAction, BENEFIT_DATA, TEAM_DATA, TEAM_NO_DATA,
  URL_FORMAT, fontOptions, fonts } from '@/imports-files/pages/career/customize-career-page';
import { CustomToastrAction, toastr } from "@/imports-files/common/common";
import { isMobile, TabletView } from 'react-device-detect';
import { dataURItoBlob } from "@/actions/common/image-base64-to-blob";

import cloneDeep from 'lodash.clonedeep';

export class CustomizeCareerAction
{
  constructor(args){
    this.customToastrAction  =   new CustomToastrAction();
    this.customizeCareerService = new CustomizeCareerService();
    this.cropperAction        =   new CustomCropperAction();
    this.commonAction = new CommonAction();
    this.sidebar_section = args.sidebar_section
    this.setLoading = args.setLoading;
    this.formRef = args.formRef;
    this.setCropperType = args.setCropperType
  }

  getJobLocation(job) {
    if (job.is_remote) {
      return job.city_country ? `Remote (${job.city_country})` : "Remote";
    } else {
      return job.city_country || "-";
    }
  }

  
  showHideSidePanel(isOpen){
    if(isOpen){
      if(document.getElementById("career_SidePanel")) document.getElementById("career_SidePanel").style.left = "50%";
      if(document.getElementById("career_SidePanel")) document.getElementById("career_SidePanel").style.width = "580px";
      document.body.classList.add('bodybg');
    }

    else{
      if(document.getElementById("career_SidePanel")) document.getElementById("career_SidePanel").style.left = "0";
      if(document.getElementById("career_SidePanel")) document.getElementById("career_SidePanel").style.width = "0";
      document.body.classList.remove('bodybg');

    }
  }




  toggleMenu(){
    var toggleBars = document.getElementById("careerHeaderDiv");
    if(toggleBars){
      if(toggleBars.classList.contains('responsive')){
         toggleBars.classList.remove("responsive");
      }
      else{
        toggleBars.classList.add("responsive");
      }
    }
  }

  bannerSize(){
    let el = document.getElementById('Hero_Back_Image')
    if(typeof window != "undefined"){
      if(window.innerWidth <=600){
        var height = window.innerWidth/0.592
        if(el) el.style.height = `${height}px`
      }
      else if(window.innerWidth >=768 && window.innerWidth <=1024){
        var height = window.innerWidth/1.03
        if(el) el.style.height = `${height}px`
      }
      else{
      var height = window.innerWidth/2
      if(el) el.style.height = `${height}px`
       }
    }
  }

  addAboutSection(){
    let page_sections_attributes = formRef.current.page_sections_attributes || []
    if(page_sections_attributes){
      let about_section = {
        title: 'About',
        description: 'Description',
        image: {}
      }
    }
  }

  addGallerySection(){
    let page_sections_attributes = formRef.current.page_sections_attributes || []
    if(page_sections_attributes){
      let about_section = {
        title: 'About',
        description: 'Description',
        image: {}
      }
    }
  }

  addBenefitSection(){
    let page_sections_attributes = formRef.current.page_sections_attributes || []
    if(page_sections_attributes){
      let about_section = {
        title: 'About',
        description: 'Description',
        image: {}
      }
    }
  }

  addTeamSection(){
    let page_sections_attributes = formRef.current.page_sections_attributes || []
    if(page_sections_attributes){
      let team_section = {
        title: 'My Team',
        description: 'Description',
        image: {}
      }
    }
  }

  setInitialValues(cp_data)
  {
    return cp_data
  }

  async updateAboutSection(formik, index){
    const page_section = formik.values.page_sections_attributes[index]
    await this.updatePageSection(formik, page_section)
  }

  async updateAboutRef(index){
    const page_section = this.formRef.current.values.page_sections_attributes[index]
    const params = {career_page: {page_sections_attributes: [page_section]}}
    this.customizeCareerService.updateCareerPage(params);
  }

  updateHeroSection(values, isImage){
    var hero_section_attributes = this.formRef.current.values.hero_section_attributes
    const params = {career_page: {hero_section_attributes: hero_section_attributes}}
    this.customizeCareerService.updateCareerPage(params);
  }

  async updatePageSection(formik, page_section){
    const params = {career_page:  { page_sections_attributes: [page_section] }}
    const result = await this.customizeCareerService.updateCareerPage(params);
    if(result.data?.career_page){
      await formik.setValues(result.data.career_page)
    }
  }

  async updateNavigationLinkSection(formik, career_navigation_links_attributes){
    const params = {career_page:  { career_navigation_links_attributes: career_navigation_links_attributes }}
    const result = await this.customizeCareerService.updateCareerPage(params);
    if(result.data?.career_page){
      await formik.setFieldValue('career_navigation_links_attributes', [...result.data.career_page.career_navigation_links_attributes])
    }
  }

  async handleLogoOnChange(event, formik)
  {
    let file  = event.target.files[0]
    if(file.size > FILE_SIZES.logo.size)
    {
      this.customToastrAction.setNormalToastr('Image size should not be greater than 2 MB.', 'warning')
    }
    else
    {
      this.logo_hash = {
                      file_name: file.name,
                      file: file,
                      file_size: file.size
                  }
      formik.setFieldValue('logo', this.logo_hash);
      var data_url = window.URL.createObjectURL(file);
      formik.setFieldValue(`logo_url`, data_url)
      var blob_data  = await dataURItoBlob(data_url);
      await this.updateLogo(blob_data)
      // document.querySelector('.CropperModal').style.visibility = 'visible';
      // var img_tag = document.querySelector('.Cropper__Image');
      // img_tag.src = this.image_url;
      // this.setCropperType({type: 'logo_image', formik: formik})
      // this.cropperAction.initialize_cropping_area('logo_image');
      event.target.value = '';
    }
    event.target.value            =   "";
  }

  updateLogo(blob_data)
  {
    const formData = new FormData();
    formData.append( "career_page[logo]",  blob_data, this.formRef.current.values.logo.file_name || this.logo_hash.file_name);
    this.customizeCareerService.updateCareerPageImages(formData);
  }

  async handleBackgroundOnChange(event, formik)
  {
    let file  = event.target.files[0]
    if(file.size > FILE_SIZES.hero.size)
    {
      this.customToastrAction.setNormalToastr('Image size should not be greater than 5 MB.', 'warning')
    }
    else if(! await this.commonAction.checkDimension(file,  FILE_SIZES.hero.minWidth, FILE_SIZES.hero.minHeight, 'hero_image')){
      this.customToastrAction.setNormalToastr(`Min image size: ${FILE_SIZES.hero.minWidth}px*${FILE_SIZES.hero.minHeight}px.`, 'warning')
    }
    else
    {
      if(! await this.commonAction.checkMinWidth(file, FILE_SIZES.hero.idealWidth, 'hero_image')){
        this.customToastrAction.setNormalToastr(`Please note, your image may appear stretched. Add a higher resolution image (minimum width 1400px) for the best image quality.`, 'warning')
      }
      this.hero_hash = {
                      file_name: file.name,
                      file: file,
                      file_size: file.size
                  }
      formik.setFieldValue('hero_section_attributes.hero_image', this.hero_hash);
      this.image_url = window.URL.createObjectURL(file);
      document.querySelector('.CropperModal').style.visibility = 'visible';
      var img_tag = document.querySelector('.Cropper__Image');
      img_tag.src = this.image_url;
      this.setCropperType({type: 'hero_image', formik: formik})
      this.cropperAction.initialize_cropping_area('hero_image');
      event.target.value = '';

      this.mobile_hash = {
                      file_name: file.name,
                      file: file,
                      file_size: file.size
                  }
      formik.setFieldValue('hero_section_attributes.mobile_image', this.mobile_hash);
    }
    event.target.value            =   "";
  }

  async handleMobileBackground(actionObject, formik){
    actionObject.image_url = window.URL.createObjectURL(actionObject.formRef.current.values.hero_section_attributes.mobile_image.file);
    document.querySelector('.CropperModal').style.visibility = 'visible';
    var img_tag = document.querySelector('.Cropper__Image');
    img_tag.src = actionObject.image_url;
    actionObject.setCropperType({type: 'mobile_image', formik: {values: actionObject.formRef.current.values}})
    actionObject.cropperAction.initialize_cropping_area('mobile_image');
  }


  updateBackground(blob_data)
  {
    const formData = new FormData();
    if(this.formRef.current.values.hero_section_attributes.id) formData.append( "career_page[hero_section_attributes][id]", this.formRef.current.values.hero_section_attributes.id)
    formData.append( "career_page[hero_section_attributes][bg_image]",  blob_data, this.formRef.current.values.hero_section_attributes.hero_image?.file_name || this.hero_hash.file_name);
    this.customizeCareerService.updateCareerPageImages(formData);
  }

  updateMobileBackground(blob_data)
  {
    const formData = new FormData();
    if(this.formRef.current.values.hero_section_attributes.id) formData.append( "career_page[hero_section_attributes][id]", this.formRef.current.values.hero_section_attributes.id)
    formData.append( "career_page[hero_section_attributes][mobile_image]",  blob_data, this.formRef.current.values.hero_section_attributes.mobile_image?.file_name || this.mobile_hash.file_name);
    this.customizeCareerService.updateCareerPageImages(formData);
  }

  async handleAboutChange(event, formik, index)
  { let file = event.target.files[0]
    if(file){
      if(file.size > FILE_SIZES.about.size)
      {
        this.customToastrAction.setNormalToastr('Image size should not be greater than 5 MB.', 'warning')
      }
      else if(! await this.commonAction.checkDimension(file,  FILE_SIZES.about.minWidth, FILE_SIZES.about.minHeight, 'about_image')){
        this.customToastrAction.setNormalToastr(`Min image size: ${FILE_SIZES.about.minWidth}px*${FILE_SIZES.about.minHeight}px.`, 'warning')
      }
      else{
        this.about_hash = {
                      file_name: file.name,
                      file: file,
                      file_size: file.size
                  }
        formik.setFieldValue(`page_sections_attributes.${index}.career_about_section_attributes.image`, this.about_hash);
        this.image_url = window.URL.createObjectURL(file);
        document.querySelector('.CropperModal').style.visibility = 'visible';
        var img_tag = document.querySelector('.Cropper__Image');
        img_tag.src = this.image_url;
        this.setCropperType({type: 'about_image', formik: formik, index: index})
        this.cropperAction.initialize_cropping_area('about_image');
      }
    }
    event.target.value = "";
  }

  updateAboutImage(formik, index, blob_data){
    const formData = new FormData();
    formData.append("career_page[page_sections_attributes][][id]", formik.values.page_sections_attributes[index].id)
    formData.append("career_page[page_sections_attributes][][career_about_section_attributes][id]", formik.values.page_sections_attributes[index].career_about_section_attributes.id)
    formData.append( "career_page[page_sections_attributes][][career_about_section_attributes][image]",  blob_data, this.formRef.current.values.page_sections_attributes[index].career_about_section_attributes.image.file_name || this.about_hash.file_name);
    this.customizeCareerService.updateCareerPageImages(formData);
  }

  async handleGalleryImage(event, formik, index, gallery_index){
    let file = event.target.files[0]
    if(file){
      if(file.size > FILE_SIZES.gallery.size)
      {
        this.customToastrAction.setNormalToastr('Image size should not be greater than 5 MB.', 'warning')
      }
      else if(! await this.commonAction.checkDimension(file,  FILE_SIZES.gallery.minWidth, FILE_SIZES.gallery.minHeight, 'gallery_image')){
        this.customToastrAction.setNormalToastr(`Min image size: ${FILE_SIZES.gallery.minWidth}px*${FILE_SIZES.gallery.minHeight}px.`, 'warning')
      }
      else{
        this.gallery_hash = {
                      file_name: file.name,
                      file: file,
                      file_size: file.size
                  }
        formik.setFieldValue(`page_sections_attributes.${index}.career_gallery_section_attributes.career_gallery_images_attributes.${gallery_index}.image`, this.gallery_hash);
        this.image_url = window.URL.createObjectURL(file);
        document.querySelector('.CropperModal').style.visibility = 'visible';
        var img_tag = document.querySelector('.Cropper__Image');
        img_tag.src = this.image_url;
        this.setCropperType({type: 'gallery_image', formik: formik, index: index, gallery_index: gallery_index})
        this.cropperAction.initialize_cropping_area('gallery_image');
      }
    }
    event.target.value = "";
  }

  updateGalleryImage(formik, index, gallery_index, blob_data){
    const formData = new FormData();
    formik.setFieldValue(`page_sections_attributes.${index}.career_gallery_section_attributes.career_gallery_images_attributes.${gallery_index}.display`, "show")
    formData.append("career_page[page_sections_attributes][][id]", formik.values.page_sections_attributes[index].id)
    formData.append("career_page[page_sections_attributes][][career_gallery_section_attributes][id]", formik.values.page_sections_attributes[index].career_gallery_section_attributes.id)
    formData.append("career_page[page_sections_attributes][][career_gallery_section_attributes][career_gallery_images_attributes][][id]", formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes[gallery_index].id)
    formData.append("career_page[page_sections_attributes][][career_gallery_section_attributes][career_gallery_images_attributes][][image]", blob_data, this.formRef.current.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes[gallery_index].image.file_name || this.gallery_hash.file_name )
    formData.append("career_page[page_sections_attributes][][career_gallery_section_attributes][career_gallery_images_attributes][][display]", 'show')
    this.customizeCareerService.updateCareerPageImages(formData);
  }

  async handleTeamImage(event, formik, index, team_index){
    let file = event.target.files[0]
    if(file){
      if(file.size > FILE_SIZES.team.size)
      {
        this.customToastrAction.setNormalToastr('Image size should not be greater than 5 MB.', 'warning')
      }
      else if(! await this.commonAction.checkDimension(file,  FILE_SIZES.team.minWidth, FILE_SIZES.team.minHeight, 'team_image')){
        this.customToastrAction.setNormalToastr(`Min image size: ${FILE_SIZES.team.minWidth}px*${FILE_SIZES.team.minHeight}px.`, 'warning')
      }
      else{
        this.team_hash = {
                      file_name: file.name,
                      file: file,
                      file_size: file.size
                  }
        formik.setFieldValue(`page_sections_attributes.${index}.career_team_section_attributes.career_team_details_attributes.${team_index}.image`, this.team_hash);
        this.image_url = window.URL.createObjectURL(file);
        document.querySelector('.CropperModal').style.visibility = 'visible';
        var img_tag = document.querySelector('.Cropper__Image');
        img_tag.src = this.image_url;
        this.setCropperType({type: 'team_image', formik: formik, index: index, team_index: team_index})
        this.cropperAction.initialize_cropping_area('team_image');
      }
    }
    event.target.value = "";
  }

  updateTeamImage(formik, index, team_index, blob_data){
    const formData = new FormData();
    formData.append("career_page[page_sections_attributes][][id]", formik.values.page_sections_attributes[index].id)
    formData.append("career_page[page_sections_attributes][][career_team_section_attributes][id]", formik.values.page_sections_attributes[index].career_team_section_attributes.id)
    formData.append("career_page[page_sections_attributes][][career_team_section_attributes][career_team_details_attributes][][id]", formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes[team_index].id)
    formData.append("career_page[page_sections_attributes][][career_team_section_attributes][career_team_details_attributes][][image]", blob_data, this.formRef.current.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes[team_index].image.file_name || this.team_hash.file_name )
    this.customizeCareerService.updateCareerPageImages(formData);
  }

  async handleBenefitImage(event, formik, index, benefit_index){
    let file = event.target.files[0]
    if(file){
      if(file.size > FILE_SIZES.benefit.size)
      {
        this.customToastrAction.setNormalToastr('Image size should not be greater than 1 MB.', 'warning')
      }
      else if(! await this.commonAction.checkDimension(file,  FILE_SIZES.benefit.minWidth, FILE_SIZES.benefit.minHeight, 'benefit_image')){
        this.customToastrAction.setNormalToastr(`Min image size: ${FILE_SIZES.benefit.minWidth}px*${FILE_SIZES.benefit.minHeight}px.`, 'warning')
      }
      else{
        this.benefit_hash = {
                      file_name: file.name,
                      file: file,
                      file_size: file.size
                  }
        formik.setFieldValue(`page_sections_attributes.${index}.career_benefit_section_attributes.career_benefit_details_attributes.${benefit_index}.image`, this.benefit_hash);
        this.image_url = window.URL.createObjectURL(file);
        document.querySelector('.CropperModal').style.visibility = 'visible';
        var img_tag = document.querySelector('.Cropper__Image');
        img_tag.src = this.image_url;
        this.setCropperType({type: 'benefit_image', formik: formik, index: index, benefit_index: benefit_index})
        this.cropperAction.initialize_cropping_area('benefit_image');
      }
    }
    event.target.value = "";
  }

  updateBenefitImage(formik, index, benefit_index, blob_data){
    const formData = new FormData();
    formData.append("career_page[page_sections_attributes][][id]", formik.values.page_sections_attributes[index].id)
    formData.append("career_page[page_sections_attributes][][career_benefit_section_attributes][id]", formik.values.page_sections_attributes[index].career_benefit_section_attributes.id)
    formData.append("career_page[page_sections_attributes][][career_benefit_section_attributes][career_benefit_details_attributes][][id]", formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes[benefit_index].id)
    formData.append("career_page[page_sections_attributes][][career_benefit_section_attributes][career_benefit_details_attributes][][image]", blob_data, this.formRef.current.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes[benefit_index].image.file_name || this.benefit_hash.file_name )
    this.customizeCareerService.updateCareerPageImages(formData);
  }


  closeCropperModal()
  {
    this.cropperAction.destroy_cropper();
    document.querySelector('.CropperModal').style.visibility = 'hidden';
  }

  zoom_in()
  {
    this.cropperAction.zoom_in();
  }

  zoom_out()
  {
    this.cropperAction.zoom_out();
  }

  getCroppedImage(props)
  {
    this.blob_data = this.cropperAction.crop_image(props);
  }

  redirectToPreview(slug, client_slug)
  {
    let preview_url        =  REDIRECT.client.career_site.career_preview;
    let protocol       =  window.location.protocol;
    let hostnamearray  =  window.location.host.split('.');
    let url            =  protocol + '//' + hostnamearray.join('.') + preview_url
    window.open(url, '_blank');
  }

  async publishCareerPage(formik, setLoading){
    const result  = await this.customizeCareerService.publishCareerPage({})
    if(result.data.success){
      // await formik.setValues(result.data.career_page)
      this.customToastrAction.setNormalToastr('Career Page published successfully.', 'success');
      window.location.reload();
    }
    else if(result.data.error){
      this.customToastrAction.setNormalToastr('Something went wrong.', 'error');
    }
    setLoading(false)
  }

  async resetCareerPage(setResetCareerPage, formik, setLoading, setFlagForRender){
    const result  = await this.customizeCareerService.resetCareerPage({})
    if(result.data.success){
      await formik.setValues(result.data.career_page)
      await setFlagForRender(Math.random()* 1000)
      this.customToastrAction.setNormalToastr('Career Page reset successfully.', 'success');
    }
    else
    if(result.data.error){
       this.customToastrAction.setNormalToastr('Something went wrong.', 'error');
    }
    setLoading(false)
    setResetCareerPage(false)
  }

  async addSection(formik, section_type, layout){
    if(formik.values.page_sections_attributes.length >= 8){
      this.customToastrAction.setNormalToastr('Maximum 8 section can be added.', 'warning')
      return
    }
    let orders = formik.values.page_sections_attributes.map((page_section) => page_section.order)
    let next_order = Math.max(...orders) + 1
    let page_sections_attributes = formik.values.page_sections_attributes
    let page_section = {}
    let new_section_title_prefix = this.newSectionTitle(formik, section_type)
    switch(section_type){
    case 'about':
      page_section = {
        order: next_order,
        type: 'about',
        career_about_section_attributes: {
          title: new_section_title_prefix + this.sidebar_section.about.title,
          description: this.sidebar_section.about.description,
          layout: layout
        }
      }
      break;
    case 'benefit':
      page_section = {
        order: next_order,
        type: 'benefit',
        career_benefit_section_attributes: {
          title: new_section_title_prefix + this.sidebar_section.benefit.title,
          layout: layout,
          career_benefit_details_attributes: this.benefit_details_data(layout)
        }
      }
      break;
    case 'team':
      page_section = {
        order: next_order,
        type: 'team',
        career_team_section_attributes: {
          title: new_section_title_prefix + this.sidebar_section.team.title,
          layout: layout,
          career_team_details_attributes: this.team_details_data(layout)
        }
      }
      break;
    case 'gallery':
      page_section = {
        order: next_order,
        type: 'gallery',
        career_gallery_section_attributes: {
          title: new_section_title_prefix + this.sidebar_section.gallery.title,
          description: this.sidebar_section.gallery.description,
          layout: layout,
          career_gallery_images_attributes: this.gallery_details_data(layout)
        }
      }
      break;
    }
    page_sections_attributes.push(page_section)
    await this.updatePageSection(formik, page_section)
    setTimeout(() => {
      let  section_link = this.formRef.current.values.page_sections_attributes[this.formRef.current.values.page_sections_attributes.length-1].uniq_reference
      const section = document.querySelector("#"+section_link);
      if(section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100)
  }

  async removeSection(formik, page_section){
    page_section._destroy = true
    await this.updatePageSection(formik, page_section)
  }

  newSectionTitle(formik, section_type){
    let oldSection = formik.values.page_sections_attributes.filter((x) => x.type == section_type)[0]
    return oldSection ? 'Copy of ' : ''
  }

  benefit_details_data(layout){
    switch(layout){
    case 'six_cards':
      return Array(6).fill(0).map((_, i) => {
        return {title: `Add title`, description: "Add description", display: 'hide'}
      })
    }
  }

  team_details_data(layout){
    switch(layout){
    case 'with_description':
      return Array(6).fill(0).map((_, i) => {
        return {name: TEAM_NO_DATA[0].name, designation: TEAM_NO_DATA[0].designation, description: TEAM_NO_DATA[0].description, display: 'hide'}
      })
    case 'without_description':
      return Array(6).fill(0).map((_, i) => {
        return {name: TEAM_NO_DATA[0].name, designation: TEAM_NO_DATA[0].designation, description: '', display: 'hide'}
      })
    }
  }

  gallery_details_data(layout){
    return Array(6).fill(0).map((_, i) => { return {display: 'show'} })
  }

  async addHFLinks(formik, type){
    const navigation_links = formik.values.career_navigation_links_attributes
    navigation_links.push({
      name: '',
      url: '',
      navigation_type: type
    })
    setTimeout(() => {
      this.updateNavigationLinkSection(formik, navigation_links)
    }, 100)
  }

  async removeHFLinks(formik, type, index){
    await formik.setFieldValue(`career_navigation_links_attributes.${index}._destroy`, true)
    setTimeout(() => {
      this.updateNavigationLinkSection(formik, this.formRef.current.values.career_navigation_links_attributes)
    }, 100)
  }

  showAddButton(formik, type){
    return formik.values.career_navigation_links_attributes.filter((navigation) => (navigation.navigation_type == type)).length < 3
  }

  async updateNavigationLink(formik, link_index){
    const navigation_link = formik.values.career_navigation_links_attributes[link_index]
    const params = {career_page: {career_navigation_links_attributes: navigation_link}}
    if(URL_FORMAT.test(navigation_link.url) || navigation_link.url == ''){
      const result = await this.customizeCareerService.updateCareerPage(params);
    }
    else{
      formik.setFieldError(event.target.name, 'Please enter valid url')
    }
  }

  async updateSocialLink(event,  formik){
    setTimeout(async() => {
      if(URL_FORMAT.test(event.target.value) || event.target.value == ''){
        const params = {career_page: { career_social_link_attributes: formik.values.career_social_link_attributes }}
        const result = await this.customizeCareerService.updateCareerPage(params);
      }
      else{
        formik.setFieldError(event.target.name, 'Please enter valid url')
      }
    }, 100)
  }

  async onDragEnd(result, formRef){
    const { destination, source } = result;
    if (!destination) {
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    let add;
    let active = formRef.current.values.page_sections_attributes;
    // Source Logic
    if (source.droppableId === "SectionsList") {
      add = active[source.index];
      active.splice(source.index, 1);
    }

    // Destination Logic
    if (destination.droppableId === "SectionsList") {
      active.splice(destination.index, 0, add);
    }
    await formRef.current.setFieldValue('page_sections_attributes', [...active])
    this.updateOrdering(formRef)
  }

  async updateOrdering(formRef){
    let page_sections = formRef.current.values.page_sections_attributes.map((x, order_index) => {
        return {order: order_index+1, id: x.id}
      })
    const params = {career_page: { page_sections_attributes: page_sections}}
    const result = await this.customizeCareerService.updateCareerPage(params);
  }

  async fontStyleChange(custom_event, formik, style, type, setFonts){
    if(type == 'button'){
      switch(style){
        case 'hero_button_background_color':
          await formik.setFieldValue(`career_button_style_attributes.hero_button.background_color`, custom_event.rgb)
          break;
        case 'hero_button_font_color':
          await formik.setFieldValue(`career_button_style_attributes.hero_button.font_color`, custom_event.rgb)
          break;
        case 'view_more_job_button_background_color':
          await formik.setFieldValue(`career_button_style_attributes.view_more_job_button.background_color`, custom_event.rgb)
          break;
        case 'view_more_job_button_font_color':
          await formik.setFieldValue(`career_button_style_attributes.view_more_job_button.font_color`, custom_event.rgb)
          break;
        case 'font_weight':
          await formik.setFieldValue('career_button_style_attributes.style_hash.fontWeight', custom_event.target.checked ? 'bold' : 'normal')
          break;
        case 'font_style':
          await formik.setFieldValue('career_button_style_attributes.style_hash.fontStyle', custom_event.target.checked ? 'italic' : 'normal')
          break;
        case 'text_decoration':
          await formik.setFieldValue('career_button_style_attributes.style_hash.textDecoration', custom_event.target.checked ? 'underline' : 'none')
          break;
        case 'font_size':
          await formik.setFieldValue('career_button_style_attributes.style_hash.fontSize', custom_event.value)
          break;
        case 'font_family':
          await this.formRef.current.setFieldValue('career_button_style_attributes.style_hash.fontFamily', custom_event.value).then(() => {
            setFonts(this.listofAllFonts())
          })
          break;
        case 'fill':
          if(custom_event.value == 'outline'){
            await  formik.setFieldValue(`career_button_style_attributes.style_hash.fill`, custom_event.value)
            await  formik.setFieldValue(`career_button_style_attributes.style_hash.fillColor`, formik.values.career_button_style_attributes.style_hash.backgroundColor)
            await  formik.setFieldValue(`career_button_style_attributes.style_hash.backgroundColor`, 'transparent')
            await  formik.setFieldValue(`career_button_style_attributes.style_hash.borderColor`, formik.values.career_button_style_attributes.style_hash.color)
          }else{
            await  formik.setFieldValue(`career_button_style_attributes.style_hash.fill`, custom_event.value)
            await  formik.setFieldValue(`career_button_style_attributes.style_hash.backgroundColor`, formik.values.career_button_style_attributes.style_hash.fillColor)
            await  formik.setFieldValue(`career_button_style_attributes.style_hash.borderColor`, formik.values.career_button_style_attributes.style_hash.fillColor)
            await  formik.setFieldValue(`career_button_style_attributes.style_hash.fillColor`, '')
          }
          break;
        case 'color':
          await formik.setFieldValue('career_button_style_attributes.style_hash.color', custom_event.rgb)
          if(formik.values.career_button_style_attributes.style_hash.fill == 'outline')
            { await formik.setFieldValue('career_button_style_attributes.style_hash.borderColor', custom_event.rgb) }
          break;
        case 'background_color':
          await formik.setFieldValue('career_button_style_attributes.style_hash.backgroundColor', custom_event.rgb)
          await formik.setFieldValue('career_button_style_attributes.style_hash.borderColor', custom_event.rgb)
          break;
        case 'border_radius':
            let new_value = isNaN(custom_event.target.value) ? formik.values.career_button_style_attributes.style_hash.borderRadius : (parseInt(custom_event.target.value) == 0 ? '' : custom_event.target.value)
            await formik.setFieldValue('career_button_style_attributes.style_hash.borderRadius', new_value)
          break;
      }
      setTimeout(this.updateButtonStyle(formik), 1000);
    }
    else if(type == 'overlay'){
      switch(style){
        case 'hero_background_overlay':
          await formik.setFieldValue(`hero_section_attributes.overlay_hash`, custom_event.rgb)
          break;
        }
       setTimeout(this.updateHeroSection(formik.values), 1000);
    }
    else{
      switch(style){
        case 'font_family':
          await formik.setFieldValue('career_font_style_attributes.font_family', custom_event.value).then(() => {
            setFonts(this.listofAllFonts(formik))
            setTimeout(this.updateFontStyle(formik), 2000);
          })
          break;
        case 'hero_font_size':
          await formik.setFieldValue('career_font_style_attributes.hero_font_size', custom_event.value)
          break;
        case 'hero_font_color':
          await formik.setFieldValue('career_font_style_attributes.hero_font_color', custom_event.rgb)
          break;
        case 'style_1_background_color':
          await formik.setFieldValue(`career_font_style_attributes.style_hash.style_1.background_color`, custom_event.rgb)
          break;
        case 'style_1_font_color':
          await formik.setFieldValue(`career_font_style_attributes.style_hash.style_1.font_color`, custom_event.rgb)
          break;
        case 'style_2_background_color':
          await formik.setFieldValue(`career_font_style_attributes.style_hash.style_2.background_color`, custom_event.rgb)
          break;
        case 'style_2_font_color':
          await formik.setFieldValue(`career_font_style_attributes.style_hash.style_2.font_color`, custom_event.rgb)
          break;
        case 'style_3_font_color':
          await formik.setFieldValue(`career_font_style_attributes.style_hash.style_3.font_color`, custom_event.rgb)
          break;
        case 'font_weight':
          await formik.setFieldValue(`career_font_styles_attributes.${index}.style_hash.fontWeight`, custom_event.target.checked ? 'bold' : 'normal')
          break;
        case 'font_style':
          await formik.setFieldValue(`career_font_styles_attributes.${index}.style_hash.fontStyle`, custom_event.target.checked ? 'italic' : 'normal')
          break;
        case 'text_decoration':
          await  formik.setFieldValue(`career_font_styles_attributes.${index}.style_hash.textDecoration`, custom_event.target.checked ? 'underline' : 'none')
          break;
        case 'font_size':
          await  formik.setFieldValue(`career_font_styles_attributes.${index}.style_hash.fontSize`, custom_event.value)
          break;
        case 'font_family':
           await formik.setFieldValue(`career_font_styles_attributes.${index}.style_hash.fontFamily`, custom_event.value).then(() => {
              setFonts(this.listofAllFonts(formik))
              setTimeout(this.updateFontStyle(formik), 2000);
           })
          break;
        case 'fill':
          await  formik.setFieldValue(`career_font_styles_attributes.${index}.style_hash.fill`, custom_event.value)
          break;

        case 'border_radius':
          await  formik.setFieldValue(`career_font_styles_attributes.${index}.style_hash.borderRadius`, custom_event.target.value)
          break;
      }
      setTimeout(this.updateFontStyle(formik), 1000);
    }
  }

  fontStyleChecked(formik, style, type, index=0){
    let career_button_style = type == 'button' ? formik.values.career_button_style_attributes :  formik.values.career_font_styles_attributes[index]
    switch(style){
      case 'font_weight':
        return career_button_style.style_hash.fontWeight == 'bold'
        break;
      case 'font_style':
        return career_button_style.style_hash.fontStyle == 'italic'
        break;
      case 'text_decoration':
        return career_button_style.style_hash.textDecoration == 'underline'
        break;
    }
  }
  updateButtonStyle(formik){
    const params = {career_page: {career_button_style_attributes: this.formRef.current.values.career_button_style_attributes}}
    const result = this.customizeCareerService.updateCareerPage(params)
  }

  updateFontStyle(formik){
    const params = {career_page: {career_font_style_attributes: this.formRef.current.values.career_font_style_attributes}}
    const result = this.customizeCareerService.updateCareerPage(params)
  }

  async showHideGalleryImage(formik, index, gallery_index, new_value){
    if(new_value == 'hide'){
      let hidden_image_count = formik.values.page_sections_attributes[index].career_gallery_section_attributes.career_gallery_images_attributes.filter((x) => x.display == 'hide').length
      if(hidden_image_count >= 3){
        this.customToastrAction.setNormalToastr('Minimum 3 images are required.', 'warning');
        return
      }
    }
    await formik.setFieldValue(`page_sections_attributes.${index}.career_gallery_section_attributes.career_gallery_images_attributes.${gallery_index}.display`, new_value)
    await this.updateAboutRef(index)
  }

  heroTitleStyle(formik){
    return {
      fontSize: formik.values.career_font_style_attributes.hero_font_size,
      fontFamily: formik.values.career_font_style_attributes.font_family,
      color: this.rgbColorStyle(formik.values.career_font_style_attributes.hero_font_color || {r: 255, g:255, b:255, a: 1})
    }
  }
  titleStyle(formik){
    return formik.values.career_font_styles_attributes?.filter((x) => x.font_type == 'title_text')[0]?.style_hash || {}
  }
  bodyStyle(formik){
    return formik.values.career_font_styles_attributes?.filter((x) => x.font_type == 'body_text')[0]?.style_hash || {}
  }
  labelStyle(formik){
    return {
            fontFamily: formik.values.career_font_style_attributes.font_family,
            color: this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_1.font_color)
          }
  }

  headerStyle(formik){
    return { fontFamily: formik.values.career_font_style_attributes.font_family }
  }

  heroButtonStyle(formik){
    let borderRadius = formik.values.career_button_style_attributes.style_hash.borderRadius ? `${formik.values.career_button_style_attributes.style_hash.borderRadius}px` : '0px'
    let button_style = {
      borderRadius: borderRadius,
      fontSize: formik.values.career_button_style_attributes.style_hash.fontSize,
      color: this.rgbColorStyle(formik.values.career_button_style_attributes.hero_button?.font_color),
      backgroundColor: this.rgbColorStyle(formik.values.career_button_style_attributes.hero_button?.background_color),
      borderColor: this.rgbColorStyle(formik.values.career_button_style_attributes.hero_button?.background_color)
    }
    return button_style
  }

  viewMoreButtonStyle(formik){
    let borderRadius = formik.values.career_button_style_attributes.style_hash.borderRadius ? `${formik.values.career_button_style_attributes.style_hash.borderRadius}px` : '0px'
    let button_style = {
      borderRadius: borderRadius,
      fontSize: formik.values.career_button_style_attributes.style_hash.fontSize,
      color: this.rgbColorStyle(formik.values.career_button_style_attributes.view_more_job_button?.font_color),
      backgroundColor: this.rgbColorStyle(formik.values.career_button_style_attributes.view_more_job_button?.background_color),
      borderColor: this.rgbColorStyle(formik.values.career_button_style_attributes.view_more_job_button?.background_color)
    }
    return button_style
  }

  fontSizeOptions(font_type){
    let labelList = ['Small', 'Medium', 'Large']
    switch(font_type){
    case 'hero_font_size':
      return [3,5,7].map((_, i) => { return {label: `${labelList[i]}`, value: `${_}em`}})
    case 'hero_text':
      return [2.375,2.625,2.875].map((_, i) => { return {label: `${labelList[i]}`, value: `${_}em`}})
    case 'title_text':
      return [2,2.25,2.5].map((_, i) => { return {label: `${labelList[i]}`, value: `${_}em`}})
    case 'body_text':
      return [1.375,1.5,1.625].map((_, i) => { return {label: `${labelList[i]}`, value: `${_}em`}})
    case 'sub_text':
      return [0.875,1,1.125].map((_, i) => { return {label: `${labelList[i]}`, value: `${_}em`}})
    case 'button_text':
      return [1,1.25,1.5].map((_, i) => { return {label: `${labelList[i]}`, value: `${_}em`}})
    }
  }
  listofAllFonts(formik){
    const fontFamilies = [this.formRef.current.values.career_font_style_attributes.font_family]
    var fontOptionsList =  fontOptions()
    return fontFamilies.map((font) => {return {
            font: font,
            weights: fontOptionsList.filter((x) => x.label == font)[0]?.variants || []
          }})
  }

  groupBy(xs, key, value) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push({font: x[value], variants: x['variants']});
        return rv;
      }, {});
    }

  fontFamilyByCategory(){
    var fontFamilyWithCategory = fontsList.items.map(fontItem => {
        return {
            family: fontItem.family,
            category: fontItem.category,
            variants: fontItem.variants
        };
    });

    var fontFamilyByCategory = this.groupBy(fontFamilyWithCategory, 'category', 'family');
    return fontFamilyByCategory;
  }

  listOfSections(){
    return this.formRef.current.values.page_sections_attributes.map((section) => {
      return {
        label: this.sectionTitle(section),
        value: section.uniq_reference
      }
    })
  }

  sectionTitle(section){
    switch(section.type){
    case 'about':
      return section.career_about_section_attributes.title
      break;
    case 'gallery':
      return section.career_gallery_section_attributes.title
      break;
    case 'benefit':
      return section.career_benefit_section_attributes.title
      break;
    case 'team':
      return section.career_team_section_attributes.title
      break;
    case 'job':
      return 'Our open jobs'
    }
  }

  onHeroButtonClick(formik, isPreview, button_index){
    if(isPreview){
      let link_type = formik.values.hero_section_attributes.button_hash.buttons[button_index].is_link
      let link = formik.values.hero_section_attributes.button_hash.buttons[button_index].link
      if(link_type == 'section'){
        const section = document.querySelector("#"+link);
        if(section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      else if(link_type == 'link' && link){
        link = this.commonAction.addHttpOrHttps(link)
        window.open(link, '_blank');
      }
    }
  }

  listOfSerifs(){
    return fonts["sans-serif"].map((fs) => {
      return {
        label: fs.font,
        value: fs.font,
        variants: fs.variants
      }
    })
  }

  async addTeamCard(formik, index, setFlagForReRender){
    const career_team_section_attributes = formik.values.page_sections_attributes[index].career_team_section_attributes
    let layout = career_team_section_attributes.layout
    const career_team_details_attributes = career_team_section_attributes.career_team_details_attributes
    if(layout == 'with_description'){
      career_team_details_attributes.push({
        name: TEAM_NO_DATA[0].name, designation: TEAM_NO_DATA[0].designation, description: TEAM_NO_DATA[0].description, display: 'hide'
      })
    }
    else{
      career_team_details_attributes.push({
        name: TEAM_NO_DATA[0].name, designation: TEAM_NO_DATA[0].designation, description: '', display: 'hide'
      })
    }
    const page_section = this.formRef.current.values.page_sections_attributes[index]
    await this.updatePageSection(formik, page_section)
    setFlagForReRender(Math.random()*1000)
  }

  async removeTeamCard(formik, index, team_index, setFlagForReRender){
    const career_team_section_attributes = formik.values.page_sections_attributes[index].career_team_section_attributes
    const career_team_details_attributes = career_team_section_attributes.career_team_details_attributes
    career_team_details_attributes[team_index]._destroy = true
    const page_section = this.formRef.current.values.page_sections_attributes[index]
    await this.updatePageSection(formik, page_section)
    setFlagForReRender(Math.random()*1000)
  }

  async addBenefitCard(formik, index, setFlagForReRender){
    const career_benefit_section_attributes = formik.values.page_sections_attributes[index].career_benefit_section_attributes
    const career_benefit_details_attributes = career_benefit_section_attributes.career_benefit_details_attributes
    career_benefit_details_attributes.push({
      title: 'Add title', description: 'Add description', display: 'hide'
    })
    const page_section = this.formRef.current.values.page_sections_attributes[index]
    await this.updatePageSection(formik, page_section)
    setFlagForReRender(Math.random()*1000)
  }

  async removeBenefitCard(formik, index, benefit_index, setFlagForReRender){
    const career_benefit_section_attributes = formik.values.page_sections_attributes[index].career_benefit_section_attributes
    const career_benefit_details_attributes = career_benefit_section_attributes.career_benefit_details_attributes
    career_benefit_details_attributes[benefit_index]._destroy = true
    const page_section = this.formRef.current.values.page_sections_attributes[index]
    await this.updatePageSection(formik, page_section)
    setFlagForReRender(Math.random()*1000)
  }

  addGalleryCard(formik, index){
    const career_gallery_section_attributes = formik.values.page_sections_attributes[index].career_gallery_section_attributes
    const career_gallery_images_attributes = career_gallery_section_attributes.career_gallery_images_attributes
    career_gallery_images_attributes.push({
      display: 'hide'
    })

    setTimeout(() => {
      const page_section = this.formRef.current.values.page_sections_attributes[index]
      this.updatePageSection(formik, page_section)
    }, 100)
  }

  removeGalleryCard(formik, index, gallery_index){
    const career_gallery_section_attributes = formik.values.page_sections_attributes[index].career_gallery_section_attributes
    const career_gallery_images_attributes = career_gallery_section_attributes.career_gallery_images_attributes
    career_gallery_images_attributes[gallery_index]._destroy = true
    setTimeout(() => {
      const page_section = this.formRef.current.values.page_sections_attributes[index]
      this.updatePageSection(formik, page_section)
    }, 100)
  }

  socialLinkClick(formik, index, team_index, isPreview, setSocialPopup, fieldName){
    let url = ''
    if(isPreview){
      switch(fieldName){
      case 'facebook_url':
        url = formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes[team_index].facebook_url
        url = this.commonAction.addHttpOrHttps(url)
        if (url) window.open(url, '_blank')
        break;
      case 'twitter_url':
        url = formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes[team_index].twitter_url
        url = this.commonAction.addHttpOrHttps(url)
        if (url) window.open(url, '_blank')
        break;
      case 'linkedin_url':
        url = formik.values.page_sections_attributes[index].career_team_section_attributes.career_team_details_attributes[team_index].linkedin_url
        url = this.commonAction.addHttpOrHttps(url)
        if (url) window.open(url, '_blank')
        break;
      }
    }
    else{
      setSocialPopup({state: true, index: index, team_index:  team_index, formik: formik})
    }
  }

  imageInfoContent(type){
    switch(type){
      case 'logo_image':
        return `Min image size: ${FILE_SIZES.logo.minWidth}px*${FILE_SIZES.logo.minHeight}px \nMax file size: 500kb`
      case 'hero_image':
        return `Minimum image size: ${FILE_SIZES.hero.minWidth}px*${FILE_SIZES.hero.minHeight}px \nMax file size: 5mb`
      case 'about_image':
        return `Minimum image size: ${FILE_SIZES.about.minWidth}px*${FILE_SIZES.about.minHeight}px \nMax file size: 2mb`
      case 'gallery_image':
        return `Minimum image size: ${FILE_SIZES.gallery.minWidth}px*${FILE_SIZES.gallery.minHeight}px \nMax file size: 2mb`
      case 'benefit_image':
        return `Minimum image size: ${FILE_SIZES.benefit.minWidth}px*${FILE_SIZES.benefit.minHeight}px \nMax file size: 500kb`
      case 'team_image':
        return `Minimum image size: ${FILE_SIZES.team.minWidth}px*${FILE_SIZES.team.minHeight}px \nMax file size: 2mb`
    }
  }

  titleLengthWarning(textContent){
    if(textContent.length == 0){
      this.customToastrAction.setNormalToastr("Section title can't be blank.", 'warning')
    }
  }

  descriptionLengthWarning(textContent){
    if(textContent.length == 0){
      this.customToastrAction.setNormalToastr("Section description can't be blank.", 'warning')
    }
  }

  setBackgroundColor(formik, section_type){
    const stylehash = {}
    switch(section_type){
      case 'job':
        stylehash.backgroundColor =  this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_1.background_color)
        break;
      case 'team':
        stylehash.backgroundColor =  this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_1.background_color)
        break;
      case 'about':
        stylehash.backgroundColor =  this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_2.background_color)
        break;
      case 'gallery':
        stylehash.backgroundColor =  this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_2.background_color)
        break;
    }
    return stylehash
  }

  setBackgroundOverlay(formik, section_type){
    const stylehash = {}
    let background_color = Object.assign({}, formik.values.career_font_style_attributes.style_hash.style_2.background_color)
    background_color.a = 0.8
    stylehash.backgroundColor =  this.rgbColorStyle(background_color)
    return stylehash
  }

  setFontColor(formik, section_type){
    const stylehash = {fontFamily: formik.values.career_font_style_attributes.font_family}
    switch(section_type){
      case 'job':
        stylehash.color =  this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_1.font_color)
        break;
      case 'team':
        stylehash.color =  this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_1.font_color)
        break;
      case 'about':
        stylehash.color =  this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_2.font_color)
        break;
      case 'gallery':
        stylehash.color =  this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_2.font_color)
        break;
    }
    return stylehash
  }

  job_benefit_heading_color(formik){
    return {
             fontFamily: formik.values.career_font_style_attributes.font_family,
             color: this.rgbColorStyle(formik.values.career_font_style_attributes.style_hash.style_3.font_color)
           }
  }

  createLink(fontFamilies){
    var fontOptionsList =  fontOptions()
    const fonts = fontFamilies.map((font) => {return {
            font: font,
            weights: fontOptionsList.filter((x) => x.label == font)[0]?.variants || []
          }})

    const families = fonts.reduce((acc, font) => {
        const family = font.font.replace(/ +/g, '+');
        const weights = (font.weights || []).join(',');

        return [
            ...acc,
            family + (weights && `:${weights}`),
        ];
    }, []).join('|');

    return `https://fonts.googleapis.com/css?family=${families}`;
  }

  loadSubTextFont(formik){
    const fontFamily = formik.values.career_font_style_attributes.font_family
    return fontFamily
  }

  hexToRGB(hexcode, alpha) {
    if (alpha) {
      return `rgba(${hexcode.r}, ${hexcode.g}, ${hexcode.b}, ${alpha})`;
    }

    return `rgb(${hexcode.r}, ${hexcode.g}, ${hexcode.b})`;
  }

  publishedDays(publishedAt){
    if(publishedAt){
      if(typeof window !== 'undefined' && window.innerWidth <= 1024){
        return publishedAt.replace('Posted ', '')
      }
      else
        return publishedAt
    }
  }

  rgbColorStyle(rgbaHash){
    return `rgba(${ rgbaHash.r }, ${ rgbaHash.g }, ${ rgbaHash.b }, ${ rgbaHash.a })`
  }

  onPastePreventStyling(event){
    // Prevent the default paste behavior
    event.preventDefault();

    // Get the plain text from the clipboard data
    const clipboardData = event.clipboardData || window.clipboardData;
    const plainText = clipboardData.getData('text/plain');

    // Insert the plain text into the editable div
    document.execCommand('insertHTML', false, plainText);
  }

  backgroundOverlayValue(formik){
    return {
      backgroundColor: this.rgbColorStyle(formik.values.hero_section_attributes.overlay_hash || {r: 255, g:255, b:255, a: 0.5})
    }
  }
}